module.exports = __webpack_public_path__ + "img/4d.0e06a67c.png";